import { createUseStyles } from 'react-jss';

import colors from "../../utils/colors";

var styles = {
  effectiveDateInfo: function effectiveDateInfo(contentWidth) {return {
      width: contentWidth || 'max-content',
      margin: '0 auto',
      marginBottom: '2.4rem',
      padding: '0.8rem 2.4rem',
      backgroundColor: colors.neutral[100],
      borderRadius: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      font: {
        size: '1.6rem',
        lineHeight: '2.4rem'
      },
      letterSpacing: '0.02rem'
    };},
  editButton: { marginLeft: '1.5rem' }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map